import {useState} from "react";
import JSZip from "jszip";
import {saveAs} from "file-saver";
import axios from "axios";
import {Button, CircularProgress, IconButton} from "@mui/material";
import {AllInclusive, Download, Recommend} from "@mui/icons-material";
import CustomBackdrop from "../../components/CustomBackdrop";
import {useParams} from "react-router-dom";
import {useTourStore} from "../../stores/TourStore";

export const BUCKET = "https://storage.googleapis.com/sticket-public-assets-prod"

const DownloadAllQrCodesButton = ({filesArray}) => {
  const {tour_id} = useParams()
  const tourName = useTourStore((state) => state.name)

  const [loading, setLoading] = useState(false);

  const downloadZipFromArray = async () => {
    setLoading(true);
    
    const zip = new JSZip();
    const BATCH_SIZE = 10; // 10 file in parallelo

    console.log(`Inizio download di ${filesArray.length} file in batch di ${BATCH_SIZE}...`);

    // Dividi in batch e processa in parallelo
    for (let i = 0; i < filesArray.length; i += BATCH_SIZE) {
      const batch = filesArray.slice(i, i + BATCH_SIZE);
      const batchNumber = Math.floor(i / BATCH_SIZE) + 1;
      const totalBatches = Math.ceil(filesArray.length / BATCH_SIZE);

      console.log(`Batch ${batchNumber}/${totalBatches} (${batch.length} file)`);

      // Download parallelo del batch corrente
      const promises = batch.map(async (fileObj) => {
        const { id, qrCodeUrl } = fileObj;

        try {
          const response = await fetch(qrCodeUrl);

          if (!response.ok) {
            throw new Error(`HTTP ${response.status}`);
          }

          const blob = await response.blob();
          zip.file(`${id}.png`, blob);

          //console.log(`✅ ${id}`);
          return { success: true, id };

        } catch (error) {
          console.error(`Error ${id}: ${error.message}`);
          return { success: false, id, error: error.message };
        }
      });

      // Attendi che il batch finisca
      await Promise.all(promises);

      // Breve pausa tra i batch (solo se non è l'ultimo)
      if (i + BATCH_SIZE < filesArray.length) {
        await new Promise(resolve => setTimeout(resolve, 100));
      }
    }

    console.log('Creazione ZIP...');
    const zipBlob = await zip.generateAsync({
      type: "blob",
      compression: "DEFLATE",
      compressionOptions: { level: 6 }
    });

    // Download del file ZIP
    const link = document.createElement('a');
    link.href = URL.createObjectURL(zipBlob);
    link.download = `qr_codes-tour-${tourName}-${tour_id}-${Date.now()}.zip`;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(link.href);

    console.log('Download completato!');
    setLoading(false);
  };

  return (
    <>
      <CustomBackdrop open={loading} children={<CircularProgress size={24} color="inherit"/>}/>
      <IconButton
        color="primary"
        onClick={downloadZipFromArray}
        disabled={loading}
      >
        {loading ?
          <CircularProgress size={24} color="inherit"/>
          : <Download/>}
      </IconButton>
    </>
  );
};

export default DownloadAllQrCodesButton;